import { formatCurrency } from "@app/deploy";
import { FormGroup } from "@app/ui/shared/form-group";
import { InputCurrency } from "@app/ui/shared/input";
import { EditPolicyLink } from "@app/ui/shared/llm-gateway-policy/edit-policy-link";

/** A blank limit means the key has none of its own, so only a value can be wrong. */
export const spendLimitValidator = (
  spendLimit: number | undefined,
  orgSpendLimit: number,
) => {
  if (spendLimit === undefined) return;
  if (spendLimit > orgSpendLimit) {
    return `Spend limit cannot exceed the organization's limit of ${formatCurrency(orgSpendLimit)}.`;
  }
};

export const LlmGatewayKeySpendLimitField = ({
  id,
  value,
  onChange,
  orgSpendLimit,
  error,
  disabled = false,
  className,
}: {
  id: string;
  value: number | undefined;
  onChange: (value: number | undefined) => void;
  orgSpendLimit: number;
  error?: string;
  disabled?: boolean;
  className?: string;
}) => {
  return (
    <FormGroup
      label="Monthly Spend Limit (optional)"
      htmlFor={id}
      description={
        <>
          Must be less than or equal to{" "}
          {formatCurrency(
            orgSpendLimit,
            Number.isInteger(orgSpendLimit) ? 0 : 2,
          )}
          , the maximum allowed by your organization. <EditPolicyLink />
        </>
      }
      feedbackMessage={error}
      feedbackVariant={error ? "danger" : "default"}
      className={className}
    >
      <InputCurrency
        id={id}
        name={id}
        value={value}
        onChange={onChange}
        placeholder={formatCurrency(orgSpendLimit)}
        disabled={disabled}
      />
    </FormGroup>
  );
};
